import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={{
      background: 'var(--bg-page)',
      padding: '3rem 1.5rem 2rem',
      textAlign: 'center',
      borderTop: '1px solid var(--border-glass)'
    }} data-testid="footer">
      <div className="container">
        <div style={{ marginBottom: '1rem' }}>
          <img
            src="/resfi-brand.svg"
            alt="resfi - Responsible Finance"
            style={{ height: '40px', width: 'auto' }}
          />
        </div>
        <p className="body-small" style={{ color: 'var(--text-muted)', marginBottom: '0.75rem' }}>
          AI-native, autonomous banking
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.25rem', marginBottom: '0.75rem' }}>
          <Link
            to="/about-us"
            data-testid="about-footer-link"
            style={{
              color: 'var(--text-secondary)',
              textDecoration: 'none',
              fontWeight: 600,
              fontSize: '0.875rem',
              transition: 'opacity 0.3s',
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = '0.7'}
            onMouseLeave={e => e.currentTarget.style.opacity = '1'}
          >
            About
          </Link>
          <span style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>|</span>
          <a
            href="/careers"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="careers-footer-link"
            style={{
              color: 'var(--text-secondary)',
              textDecoration: 'none',
              fontWeight: 600,
              fontSize: '0.875rem',
              transition: 'opacity 0.3s',
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = '0.7'}
            onMouseLeave={e => e.currentTarget.style.opacity = '1'}
          >
            Careers
          </a>
          <span style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>|</span>
          <Link
            to="/privacy-policy"
            data-testid="privacy-footer-link"
            style={{
              color: 'var(--text-secondary)',
              textDecoration: 'none',
              fontWeight: 600,
              fontSize: '0.875rem',
              transition: 'opacity 0.3s',
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = '0.7'}
            onMouseLeave={e => e.currentTarget.style.opacity = '1'}
          >
            Privacy Policy
          </Link>
        </div>
        <p className="body-small" style={{ color: 'var(--text-muted)', marginBottom: '0.5rem' }}>
          Contact us: <a href="mailto:asheet@resfi.ai" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>asheet@resfi.ai</a>
        </p>
        <p className="body-small" style={{ color: 'var(--text-muted)', marginBottom: '1.5rem' }}>
          &copy; 2026 resfi. All rights Reserved.
        </p>
        <p style={{ 
          fontSize: '0.7rem', 
          color: 'var(--text-muted)', 
          maxWidth: '700px', 
          margin: '0 auto',
          lineHeight: 1.5,
          opacity: 0.8
        }}>
          <sup style={{ fontSize: '0.85em', marginRight: '3px' }}>1</sup>resfi is operated by ResFin LLC, a financial technology company. ResFin LLC is not a bank. Banking services, if offered, will be provided by partner banks. Deposit insurance, if applicable, will be provided by such partner banks.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
